import { render, staticRenderFns } from "./BulkDiscountTab.vue?vue&type=template&id=ef0c2ace&scoped=true"
import script from "./BulkDiscountTab.vue?vue&type=script&lang=js"
export * from "./BulkDiscountTab.vue?vue&type=script&lang=js"
import style0 from "./BulkDiscountTab.vue?vue&type=style&index=0&id=ef0c2ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0c2ace",
  null
  
)

export default component.exports